import { render } from "./user-actions.vue?vue&type=template&id=5a36beeb&ts=true"
import script from "./user-actions.ts?vue&type=script&lang=ts&external"
export * from "./user-actions.ts?vue&type=script&lang=ts&external"

import "./user-actions.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__